import {
  ADD_USER_FAILURE,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
} from "./UserTypes";

export const addUserRequest = (payload) => ({
  type: ADD_USER_REQUEST,
  payload,
});

export const addUserSuccess = (message) => ({
  type: ADD_USER_SUCCESS,
  payload: message,
});

export const addUserFailure = (error) => ({
  type: ADD_USER_FAILURE,
  payload: error,
});
export const resetUserState = () => ({
  type: "RESET_USER_STATE",
});
